// 需要缓存在localstorage的key
export const TOKEN = "PAC_BOP_Token";
export const TABS = "PAC_BOP_Tabs";
export const ADVID = "PAC_BOP_AdvId";
export const COLUMN = "PAC_BOP_ListColumn";
export const ACCOUNT = "PAC_BOP_Account";
export const RESETCACHE = "PAC_BOP_ResetCache";
export const VERSION = "PAC_BOP_AppVersion";
export const LOGIN = "PAC_BOP_Login";
export const SIDEBAR_STATUS = "PAC_BOP_sidebar_status";
export const CAS_TOKEN = "PAC_BOP_CAS_Token";
export const CAS_ACCOUNTS = "PAC_BOP_CAS_Accounts";
export const LOGIN_MODE = "PAC_BOP_LoginMode";

// 缓存在localstorage中的可枚举的value
export const LOGIN_MODE_CAS = "PAC_BOP_LoginMode_CAS";
export const LOGIN_MODE_NORMAL = "PAC_BOP_LoginMode_Normal";
